import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import Link from 'next/link'

import { UserAvatar } from '@/components/common/Team/UserAvatar'
import { getMenuItem, MenuItem } from '@/components/ui/common/MenuItem'
import { IntlFunction } from '@/utils/messages'

import { User } from '@/types/index.d'

export function UserSubMenu(user: User, t: IntlFunction): MenuItem {
  return getMenuItem(
    user.name,
    'user',
    <UserAvatar
      avatar={user.avatar}
      user={true}
      email={user.email}
      name={user.name}
      noTooltip={true}
      shape="square"
      size="large"
    />,
    [
      getMenuItem(
        <Link href="/user" style={{ width: '100%' }}>
          <span className="menu-item-title">
            {t('HeaderMenu.user.profile')}
          </span>
        </Link>,
        'profile',
        <UserOutlined />
      ),
      getMenuItem(
        <Link href="/user/settings" style={{ width: '100%' }}>
          <span className="menu-item-title">
            {t('HeaderMenu.settings.user')}
          </span>
        </Link>,
        'settings',
        <SettingOutlined />
      ),
      getMenuItem(
        <Link href="/logout" style={{ width: '100%' }}>
          <span className="menu-item-title"> {t('HeaderMenu.logout')}</span>
        </Link>,
        'logout',
        <LogoutOutlined />
      ),
    ]
  )
}
